import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of, timer } from 'rxjs';
import { map, catchError, debounceTime, switchMap, first } from 'rxjs/operators';
import { ContactService } from '@app/contacts/shared/contact.service';

@Injectable({
  providedIn: 'root'
})
export class UniqueValidator {
  constructor(private contactService: ContactService) {}

  uniqueEmail(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value || control.value.length < 3) {
        return of(null);
      }

      return timer(200).pipe(
        switchMap(() => this.contactService.fieldIsUnique('email', control.value)),
        map(response => response.is_unique ? null : { emailTaken: true }),
        catchError(() => of(null))
      );
    };
  }

  uniqueName(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      if (!control.value || control.value.length < 3) {
        return of(null);
      }

      return timer(200).pipe(
        switchMap(() => this.contactService.fieldIsUnique('name', control.value)),
        map(response => response.is_unique ? null : { nameTaken: true }),
        catchError(() => of(null))
      );
    };
  }
}